module.exports = __webpack_public_path__ + "cf2a6983741581099b3be4081f481425.pdf";